"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadiusSlider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = _interopRequireDefault(require("../../utils/useOurTranslation"));

var _Optimizers = require("../../utils/Optimizers");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _Zoom = _interopRequireDefault(require("@material-ui/core/Zoom"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("../Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * default styling for RadiusSlider
 */
var sliderHeight = parseInt(_styleModule.default.rangeSliderHeight);
var StyledSlider = (0, _withStyles.default)({
  root: {
    height: sliderHeight
  }
})(_Slider.default);

var ThumbComponent = function ThumbComponent(props) {
  var t = (0, _useOurTranslation.default)("profile-components:ThumbComponent");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Zoom.default, {
    in: true,
    style: {
      transitionDelay: '500ms'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _extends2.default)({}, props, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _styleModule.default.thumbLabel,
        children: t('label')
      })
    }))
  });
};
/**
 * RangeSlider component for whitelabel registration funnel
 * @param {config} funnel config object
 * @param {contextActions} functions from ProfileProver
 * @param {context} profile context from ProfileProvider
 */


var RadiusSliderComponent = function RadiusSliderComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.default)("profile-components:RadiusSlider");

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var handleCommit = function handleCommit(event, newValue) {
    var minimum = context[config.valueName] && context[config.valueName].value.radius ? context[config.valueName].value.radius.minimum : 0;
    var maximum = parseInt(newValue);
    var payload = {
      radius: {
        maximum: maximum,
        minimum: minimum
      }
    };
    setValue(config.valueName, payload);
  };

  var _useState = (0, _react.useState)(config.defaultValue.radius.maximum),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sliderValue = _useState2[0],
      setSliderValue = _useState2[1];

  var handleSlide = function handleSlide(event, newValue) {
    var maximum = parseInt(newValue);
    setSliderValue(maximum);
  }; // Ensure consistency between local state and commited state


  (0, _react.useEffect)(function () {
    context[config.valueName] && context[config.valueName].value.radius ? setSliderValue(context[config.valueName].value.radius.maximum) : setSliderValue(20);
  }, [config.valueName, context]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      spacing: 3,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 8,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "".concat(_styleModule.default.value),
          children: t('text')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 4,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "".concat(_styleModule.default.right, " ").concat(_styleModule.default.value),
          children: [sliderValue, t('unit')]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSlider, {
          onChangeCommitted: handleCommit,
          onChange: handleSlide,
          value: sliderValue,
          ThumbComponent: ThumbComponent,
          defaultValue: config.defaultValue.radius.maximum,
          min: config.defaultValue.radius.minimum,
          step: 5
        })
      })]
    })
  });
};

var RadiusSliderWrapper = (0, _Optimizers.memoizeComponentByValue)(RadiusSliderComponent);

var RadiusSlider = function RadiusSlider(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadiusSliderWrapper, {
    config: config,
    context: context
  });
};

exports.RadiusSlider = RadiusSlider;